// Code review - In Progress
// Documentation - In Progress
import { useEffect, useState } from "react";
import { mainTable } from "../css/Common";
import MainLayout from "../components/MainLayout";
import InputText from "../ReusableComponents/InputText";
import MainPopup from "../popup-containers/MainPopup";
import { brandExcelExportHeaders, brandHeaders } from "../components/HeaderAttribute";
import toast from "react-hot-toast";
import {
  BindAPI,
  IUDAPI,
  LanguageTranslatorAPI,
} from "../services/APIConnection";
import { useLocation, useNavigate } from "react-router-dom";
import BrandPopup from "../popup-containers/BrandPopup";
import GridPage from "../components/GridPage";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import Buttons from "../components/Buttons";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import PopUpButtons from "../components/PopUpButtons";
import ErrorPopup from "../ReusableComponents/ErrorPopup";
import Loader from "../ReusableComponents/Loader";
import * as XLSX from "sheetjs-style";
const BrandMaster = () => {
  const location = useLocation();
  // All visible functionality useState hooks handling.
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [viewDetails, setViewDetails] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [addScreenTitle, setAddScreenTitle] = useState(false);
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);

  //brand Master insert and edit useState hooks handling .

  const [brands, setBrands] = useState([""]);
  const [brandValidationErrors, setBrandValidationErrors] = useState([""]);
  const [commodities, setCommodities] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  //brand master Error handle useStates
  const [brandMasterError, setBrandMasterError] = useState({
    commoditiesError: "",
    commoditiesCategoryError: "",
    nameError: "",
  });

  const [brandFileds, setBrandFileds] = useState({
    brandCategory: "",
    brandName: "",
  });

  const [mstBrandId, setMstBrandId] = useState("");
  // All bind data value useState hooks handling.
  const [bindBrandData, setBindBrandData] = useState([]);
  const [brandPopupData, setBrandPopupData] = useState("");
  const [brandPopupDropDownData, setBrandPopupDropDownData] = useState({});
  const [bindCommoditiesCategory, setBindCommoditiesCategory] = useState([]);
  const [bindCommodities, setBindCommodities] = useState([]);

  const [rowIndex, setRowIndex] = useState("");
  const [popUpOpen, setpopUpOpen] = useState(false);

  //Auto dropdown value handle
  const [commoditiesDD, setCommoditiesDD] = useState([]);
  const [commoditiesCategoryDD, setcommoditiesCategoryDD] = useState([]);
  const [nameDD, setNameDD] = useState([]);

  const [isOpen, setIsOpen] = useState(false);

  const cancel = async () => {
    callBindBrandData(); // wait for API to finish
    setIsLoading(false); // start loader
    setVisibleAdd(false);
    setVisibleTable(true);
    setpopUpOpen(false);
    setSubmitBtnDisabled(false);
    setCommodities("");
    setBrands([""]);
    setRowIndex("");
    setMstBrandId("");
    setBrandMasterError({
      brandsError: "",
      commoditiesError: "",
      commoditiesCategoryError: "",
      nameError: "",
    });
    setBrandValidationErrors([""]);
    setBrandFileds({
      brandCategory: "",
      brandName: "",
    });
  };

  const callBindBrandData = async () => {
    try {
      setIsLoading(true);
      const response = await BindAPI("BrandAPI/BindBrand");
      setBindBrandData(response.data.Table);
    } catch (error) {
      console.error("Error fetching brand data", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchAllData();
    callBindBrandData();
  }, []);
  const fetchAllData = async () => {
    try {
      setIsLoading(true);

      // Run all requests in parallel
      const [
        categoryResponse,
        commoditiesResponse,
        categoryTypeResponse,
        brandResponse,
      ] = await Promise.all([
        BindAPI("CommoditiesAPI/GetCommoditiesCategory"),
        BindAPI("CommoditiesAPI/BindCommodities"),
        BindAPI("CommoditiesAPI/BindCommodityType"),
        BindAPI("BrandAPI/BindBrand"),
      ]);

      // ✅ Filter CommodityType
      const filteredType = categoryTypeResponse.data.Table.filter(
        (item) => item.BlockedBy === null
      );
      const categoryTypeData = filteredType.map((item) => ({
        value: item.MstCommodityTypeId,
        label: item.CommodityType_en,
      }));
      setCommoditiesDD(categoryTypeData);

      // ✅ Filter Category
      const filteredCategory = categoryResponse.data.Table.filter(
        (item) => item.BlockedBy === null
      );
      setBindCommoditiesCategory(filteredCategory);

      // ✅ Filter Commodities
      const filteredCommodities = commoditiesResponse.data.Table.filter(
        (item) => item.BlockedBy === null
      );
      setBindCommodities(filteredCommodities);

      // ✅ Brand
      setBindBrandData(brandResponse.data.Table);
    } catch (error) {
      console.error("Error fetching dropdown data", error);
    } finally {
      setIsLoading(false); // ✅ only after all APIs are done
    }
  };

  const handleOpen = (isOpen) => {
    setpopUpOpen(isOpen);
  };

  const handleBrandDetails = (rowIndex, flag) => {
    handleOpen(true);

    setViewDetails(false);
    setDeleteDetails(false);
    setBlockDetails(false);
    setUnBlockDetails(false);

    if (flag === 1) {
      setViewDetails(true);
    } else if (flag === 3) {
      setDeleteDetails(true);
      setRowIndex(rowIndex);
    } else if (flag === 4) {
      setBlockDetails(true);
      setRowIndex(rowIndex);
    } else if (flag === 5) {
      setUnBlockDetails(true);
      setRowIndex(rowIndex);
    }

    setBrandPopupData(bindBrandData[rowIndex]);

    const commodityDropDownView = commoditiesDD.find(
      (x) => x.value == bindBrandData[rowIndex].MstCommodityTypeId
    );
    const commodityViewDD = {
      value: commodityDropDownView.MstCommodityTypeId,
      label: commodityDropDownView ? commodityDropDownView.label : "Unknown",
    };
    setCommodities(bindBrandData[rowIndex].MstCommodityTypeId);

    const brandData = bindBrandData[rowIndex];
    const blockInfo = bindCommoditiesCategory.find(
      (SD) => SD.MstCommodityCategoryId === brandData.MstCommodityCategoryId
    );
    const categoryViewDD = {
      value: brandData.MstCommodityCategoryId,
      label: blockInfo ? blockInfo.CommodityCategory_en : "Unknown",
    };

    const nameDropDownView = bindBrandData[rowIndex];
    const nameInfo = bindCommodities.find(
      (SD) => SD.MstCommoditiesId === nameDropDownView.MstCommoditiesId
    );
    const nameViewDD = {
      value: nameDropDownView.MstCommodityCategoryId,
      label: nameInfo ? nameInfo.CommodityName_en : "Unknown",
    };
    const sendPopupDropDownDatas = [
      commodityViewDD,
      categoryViewDD,
      nameViewDD,
    ];
    setBrandPopupDropDownData(sendPopupDropDownDatas);
  };

  const handleEdit = (rowIndex) => {
    setUpdateScreenTitle(true);
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(false);
    setMstBrandId(bindBrandData[rowIndex].MstBrandId);
    setCommodities(bindBrandData[rowIndex].MstCommodityTypeId);

    setBrands([bindBrandData[rowIndex].Brand_en]);

    setBrandFileds({
      ...brandFileds,
      brandCategory: bindBrandData[rowIndex].MstCommodityCategoryId,
      brandName: bindBrandData[rowIndex].MstCommoditiesId,
    });
  };

  const showAdd = () => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(true);
    setUpdateScreenTitle(false);
  };

  const validate = (flag) => {
    // Initialize an object to store validation errors for each field
    const errors = {};

    if (flag === 1 || flag === 2) {
      if (commodities === "") {
        errors.commodities = "Select commodities";
      }

      if (brandFileds.brandCategory === "") {
        errors.commoditiesCategory = "Select Category";
      }

      if (brandFileds.brandName === "") {
        errors.name = "Select name";
      }

      const updatedValidationErrors = [];

      brands.forEach((brand, index) => {
        updatedValidationErrors[index] = isBrandValid(brand)
          ? ""
          : "Enter brand";
      });

      if (brands.some((brand) => brand.trim() !== "")) {
        // Clear the errors if brands have data
        setBrandValidationErrors([]);
        delete errors.updatedValidationErrors;
      } else {
        setBrandValidationErrors(updatedValidationErrors);
        errors.updatedValidationErrors = updatedValidationErrors;
      }
    }

    // Create the setBrandMasterError object
    const brandMasterErrorObject = {
      commoditiesError: errors.commodities || "",
      commoditiesCategoryError: errors.commoditiesCategory || "",
      nameError: errors.name || "",
    };

    setBrandMasterError(brandMasterErrorObject);
    console.log("Errors", errors);
    return errors;
  };

  const createdBy = sessionStorage.getItem("createdBy");

  const handleSubmit = async (items, flag) => {
    setSubmitBtnDisabled(true);
    setIsLoading(true);

    const validation = validate(flag);
    if (Object.keys(validation).length !== 0) {
      setIsOpen(true);
    }
    if (Object.keys(validation).length == 0) {
      setIsOpen(false);
      if (flag == 1 || flag == 2) {
        const languageKeys = [
          "ta", // Tamil
          "hi", // Hindi
          "mr", // Marathi
          "gu", // Gujarati
          "kn", // Kannada
          "ml", // Malayalam
          "te", // Telugu
          "bn", // Bengali
          "or", // Oriya
        ];

        const translatedTextsArray2 = [];
        const validBrands = brands.filter(
          (brand) => brand && brand.trim() !== ""
        );
        let i = 0;
        for (let brand of brands) {
          if (!brand || brand.trim() === "") {
            //console.warn("Skipping empty or null brand");
            continue;
          }
          i = i + 1;

          for (let language of languageKeys) {
            const translateText = await LanguageTranslatorAPI(brand, language);
            translatedTextsArray2.push(
              translateText.data.data.translations[0].translatedText
            );
          }
          if (flag == 1) {
            const mstBrandPayload = [
              {
                mstBrandId: mstBrandId ? mstBrandId : 0,
                mstCommodityTypeId: commodities,
                mstCommodityCategoryId: brandFileds.brandCategory,
                mstCommoditiesId: brandFileds.brandName,
                brand_en: brand,
                brand_ta: translatedTextsArray2[0],
                brand_hi: translatedTextsArray2[1],
                brand_mr: translatedTextsArray2[2],
                brand_gu: translatedTextsArray2[3],
                brand_kn: translatedTextsArray2[4],
                brand_ml: translatedTextsArray2[5],
                brand_te: translatedTextsArray2[6],
                brand_bn: translatedTextsArray2[7],
                brand_or: translatedTextsArray2[8],
                createdBy: createdBy,
                flag: flag,
              },
            ];

            const response = await IUDAPI(mstBrandPayload, "BrandAPI/IUDBrand");
            if (i == validBrands.length) {
              if (response.data.Table[0].Result === "S") {
                toast.success("brand added successfully 👍", {
                  duration: 3000,
                  position: "top-center",
                });
                setTimeout(cancel, 3000);
              } else {
                toast.error("Failed to add brand data 👎", {
                  duration: 2000,
                  position: "top-center",
                });
              }
            }
          } else if (flag == 2) {
            const mstBrandPayload = [
              {
                mstBrandId: mstBrandId ? mstBrandId : 0,
                mstCommodityTypeId: commodities,
                mstCommodityCategoryId: brandFileds.brandCategory,
                mstCommoditiesId: brandFileds.brandName,
                brand_en: brand,
                brand_ta: translatedTextsArray2[0],
                brand_hi: translatedTextsArray2[1],
                brand_mr: translatedTextsArray2[2],
                brand_gu: translatedTextsArray2[3],
                brand_kn: translatedTextsArray2[4],
                brand_ml: translatedTextsArray2[5],
                brand_te: translatedTextsArray2[6],
                brand_bn: translatedTextsArray2[7],
                brand_or: translatedTextsArray2[8],
                createdBy: createdBy,
                flag: flag,
              },
            ];
            const response = await IUDAPI(mstBrandPayload, "BrandAPI/IUDBrand");
            console.log("resposeBrand", response);
            if (i == validBrands.length) {
              if (response.data.Table[0].Result === "M") {
                toast.success("brand updated successfully 👍", {
                  duration: 3000,
                  position: "top-center",
                });
                setTimeout(cancel, 3000);
              } else {
                toast.error("Failed to update brand data 👎", {
                  duration: 2000,
                  position: "top-center",
                });
                setTimeout(cancel, 2000);
              }
            }
          }
          translatedTextsArray2.length = 0;
        }
      } else {
        const data = {
          mstBrandId: bindBrandData[items].MstBrandId,
          createdBy: createdBy,
          flag: flag,
        };

        const response = await IUDAPI([data], "BrandAPI/IUDBrand");

        if (flag == 3) {
          if (response.data.Table[0].Result === "D") {
            toast.success("brand data deleted successfully 🗑️", 5000, cancel());
            cancel();
          } else {
            toast.error("Failed to delete brand data 👎", {
              duration: 2000,
              position: "top-center",
            });
            setTimeout(cancel, 2000);
          }
        } else if (flag == 4) {
          if (response.data.Table[0].Result === "B") {
            toast.success("brand data blocked successfully 🚫", 5000, cancel());
            cancel();
          } else {
            toast.error("Failed to block brand data 👎", {
              duration: 2000,
              position: "top-center",
            });
            setTimeout(cancel, 2000);
          }
        } else if (flag == 5) {
          if (response.data.Table[0].Result === "UB") {
            toast.success(
              "brand data unblocked successfully ✅",
              5000,
              cancel()
            );
            cancel();
          } else {
            toast.error("Failed to unblock brand data 👎", {
              duration: 2000,
              position: "top-center",
            });
            setTimeout(cancel, 2000);
          }
        }
      }
    } else {
      setSubmitBtnDisabled(false);
      setIsLoading(false);
    }
  };

  const addBrandInput = () => {
    setBrands([...brands, ""]);
  };

  const removeBrandInput = (index) => {
    if (brands.length > 1) {
      // Ensure at least one brand remains
      const newBrands = [...brands];
      newBrands.splice(index, 1);
      setBrands(newBrands);
    }
  };

  const handleBrandChange = (index, value) => {
    const newBrands = [...brands];
    newBrands[index] = value;
    setBrands(newBrands);
  };

  const handleCategoryDropDown = (value) => {
    setBrandFileds({
      ...brandFileds,
      brandCategory: "",
      brandName: "",
    });
    setCommodities(value.value);
  };

  useEffect(() => {
    if (commodities) {
      const getFilteredCategory = bindCommoditiesCategory
        .filter((item) => item.MstCommodityTypeId == commodities)
        .map((items) => ({
          value: items.MstCommodityCategoryId,
          label: items.CommodityCategory_en,
        }));

      setcommoditiesCategoryDD(getFilteredCategory);
    } else {
      setcommoditiesCategoryDD([]);
    }

    if (brandFileds.brandCategory) {
      const selectedCommoditiesCategory = bindCommodities
        .filter(
          (item) => item.MstCommodityCategoryId == brandFileds.brandCategory
        )
        .map((items) => ({
          value: items.MstCommoditiesId,
          label: items.CommodityName_en,
        }));

      setNameDD(selectedCommoditiesCategory);
    } else {
      setNameDD([]);
    }
  }, [
    commodities ? commodities : null,
    brandFileds.brandCategory ? brandFileds.brandCategory : null,
  ]);

  const isBrandValid = (brand) => {
    // You can add your validation logic here
    return brand.length > 0; // Example: Check if the brand is not empty
  };
  const handleBrandBlur = (index) => {
    const updatedValidationErrors = [...brandValidationErrors];
    updatedValidationErrors[index] = isBrandValid(brands[index])
      ? ""
      : "Enter brand";
    setBrandValidationErrors(updatedValidationErrors);
  };

  const handleBrandFieldsChange = (value, name) => {
    setBrandFileds({
      ...brandFileds,
      [name]: value,
    });
  };
  useEffect(() => {
    if (location.pathname == "/brandmaster") {
      setAddScreenTitle(false);
      setVisibleTable(true);
      setVisibleAdd(false);
    }
  }, [location]);

  const handleExport = async () => {
    const locationResponse = await BindAPI("BrandAPI/ExcelExportBrand");




    // ✅ EXPORT WITH LOCAL DATA (IMMEDIATE)
    exportData(
      brandExcelExportHeaders.map((column) => column.title),
      locationResponse.data.Table
    );
  };


  const exportData = (columns, rows, dateRange, selectedDetails) => {
    // Title row configuration
    const titleRow = [
      {
        v: "Brand",
        s: {
          font: { bold: true, sz: 16 },
          alignment: { horizontal: "left" },
        },
      },
    ];




    // Add "Row Total" to headers
    const headerRow = [
      ...columns.map((column) => ({
        v: column,
        s: {
          fill: { fgColor: { rgb: "2D2D6E" } },
          font: { bold: true, color: { rgb: "FFFFFF" } },
          alignment: { horizontal: "left" },
        },
      })),

    ];



    const dataRows = rows.map((rowData, index) => {
      const isAlternateRow = index % 2 === 1;
      const rowStyle = isAlternateRow
        ? { fill: { fgColor: { rgb: "F0F0F0" } } }
        : {};

      return [
        { v: index + 1, s: rowStyle },
        { v: rowData.MstBrandId, s: rowStyle },
        { v: rowData.CommodityType_en, s: rowStyle },
        { v: rowData.CommodityCategory_en, s: rowStyle },
        { v: rowData.CommodityName_en, s: rowStyle },

        { v: rowData.Brand_en, s: rowStyle },
        { v: rowData.Brand_ta, s: rowStyle },
        { v: rowData.Brand_hi, s: rowStyle },
        { v: rowData.Brand_bn, s: rowStyle },
        { v: rowData.Brand_kn, s: rowStyle },
        { v: rowData.Brand_ml, s: rowStyle },
        { v: rowData.Brand_gu, s: rowStyle },
        { v: rowData.Brand_mr, s: rowStyle },
        { v: rowData.Brand_te, s: rowStyle },
        { v: rowData.Brand_or, s: rowStyle },
        { v: rowData.CreatedBy, s: rowStyle },

      ];
    });



    // Combine all rows
    const wsData = [
      titleRow,
      headerRow,
      ...dataRows,
    ];
    // const wsData = [headerRow, ...dataRows];
    const ws = XLSX.utils.aoa_to_sheet(wsData);

    // Set custom column widths
    ws["!cols"] = [
      { width: 8 }, // Index
      { width: 20 }, // Branch
      { width: 20 }, // Branch
      { width: 30 }, // Services
      { width: 30 }, // Services
      { width: 30 }, // Services
      { width: 30 }, // Services
      { width: 30 }, // Services
      { width: 30 }, // Services
      { width: 30 }, // Services
      { width: 30 }, // Services
      { width: 30 }, // Services
      { width: 30 }, // Services
      { width: 30 }, // Services
      { width: 30 }, // Services
      { width: 30 }, // Services
    ];

    ws["!rows"] = [
      { hpt: 30 }, // Title row height
      { hpt: 15 }, // Date range row height
      { hpt: 15 }, // Branch row height (taller for wrapped content)
      { hpt: 15 }, // Spacing row height
      { hpt: 15 }, // Header row height (taller for wrapped content)
      ...Array(rows.length).fill({ hpt: 15 }), // Data rows height
      { hpt: 15 }, // Totals row height
    ];

    // Apply borders and styles
    const applyStyles = (ws) => {
      const range = XLSX.utils.decode_range(ws["!ref"]);
      for (let R = range.s.r; R <= range.e.r; R++) {
        for (let C = range.s.c; C <= range.e.c; C++) {
          const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
          if (!ws[cellRef]) continue;

          // Add borders to all cells
          ws[cellRef].s = {
            ...ws[cellRef].s,
            border: {
              top: { style: "thin", color: { rgb: "000000" } },
              bottom: { style: "thin", color: { rgb: "000000" } },
              left: { style: "thin", color: { rgb: "000000" } },
              right: { style: "thin", color: { rgb: "000000" } },
            },
          };
        }
      }
    };

    applyStyles(ws);

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "Brand.xlsx");
  };

  return (
    <MainLayout pageName="2">
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      {visibleTable && (
        <GridPage
          title={`Brand`}
          header={brandHeaders}
          records={bindBrandData}
          handleEdit={handleEdit}
          handleAction={handleBrandDetails}
          showAdd={showAdd}
          blockView={true}

          handleExport={handleExport}
          handleExportBtn={true}
        />
      )}
      {visibleAdd && (
        <div class="w-full">
          <div class=" border-black  ">
            <div class="text-black text-2xl font-bold my-2">
              {addScreenTitle && (
                <div class={mainTable.addScreenTitle}>
                  {"Brand Master - Add"}
                </div>
              )}

              {updateScreenTitle && (
                <div class={mainTable.addScreenTitle}>
                  {"Brand Master - Edit"}
                </div>
              )}
            </div>
          </div>

          <div class="mx-auto flex  border-black">
            <div class="relative w-full h-full  md:h-auto">
              <div class="relative bg-white rounded-lg  ">
                <div class="px-6 py-6 lg:px-8">
                  <form className={mainTable.grid3}>
                    <AutoDropDown
                      Class="Custom-class"
                      title="Commodities"
                      options={commoditiesDD}
                      classStar="text-red-500"
                      placeholder="Select"
                      name="commodities"
                      selectedOption={commoditiesDD.find(
                        (x) => x.value == commodities
                      )}
                      controlFunc={handleCategoryDropDown}
                      controlFuncBlur={() => {
                        setBrandMasterError(() => ({
                          ...brandMasterError,
                          commoditiesError: commodities
                            ? ""
                            : "Select commodities",
                        }));
                      }}
                      errorMessage={brandMasterError.commoditiesError}
                    />

                    <AutoDropDown
                      Class="Custom-class"
                      title="Category"
                      options={commoditiesCategoryDD}
                      classStar="text-red-500"
                      placeholder="Select"
                      name="brandCategory"
                      selectedOption={
                        brandFileds.brandCategory
                          ? commoditiesCategoryDD.find(
                            (x) => x.value == brandFileds.brandCategory
                          )
                          : ""
                      }
                      controlFunc={(value, e) => {
                        handleBrandFieldsChange(value.value, e.name);
                        setBrandFileds({
                          ...brandFileds,
                          brandCategory: value.value,
                          brandName: "",
                        });
                      }}
                      controlFuncBlur={() => {
                        setBrandMasterError(() => ({
                          ...brandMasterError,
                          commoditiesCategoryError: brandFileds.brandCategory
                            ? ""
                            : "Select category",
                        }));
                      }}
                      errorMessage={brandMasterError.commoditiesCategoryError}
                    />

                    <AutoDropDown
                      Class="Custom-class"
                      title="Name"
                      options={nameDD}
                      classStar="text-red-500"
                      placeholder="Select"
                      name="brandName"
                      selectedOption={
                        brandFileds.brandName
                          ? nameDD.find((x) => x.value == brandFileds.brandName)
                          : ""
                      }
                      controlFunc={(value, e) => {
                        handleBrandFieldsChange(value.value, e.name);
                      }}
                      controlFuncBlur={() => {
                        setBrandMasterError(() => ({
                          ...brandMasterError,
                          nameError: brandFileds.brandName ? "" : "Select name",
                        }));
                      }}
                      errorMessage={brandMasterError.nameError}
                    />
                    {brands.map((brand, index) => (
                      <div key={index} className="flex items-center">
                        <InputText
                          inputType={"text"}
                          title={`Brand ${index + 1}`}
                          name={`brand${index}`}
                          content={brand}
                          maxLength={200}
                          classDiv={"w-full"}
                          classStar="text-red-500"
                          controlFunc={(e) =>
                            handleBrandChange(index, e.target.value)
                          }
                          controlFuncBlur={() => handleBrandBlur(index)}
                          errorMessage={
                            brandValidationErrors &&
                            brandValidationErrors[index]
                          }
                        />
                        {addScreenTitle && (
                          <div className="ml-2 flex flex-col align-baseline gap-1 mt-3">
                            <svg
                              viewBox="0 0 1024 1024"
                              fill="currentColor"
                              onClick={addBrandInput}
                              className="w-5 h-5 text-black cursor-pointer"
                              role="button"
                              aria-label="Add Brand"
                            >
                              <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm192 472c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z" />
                            </svg>
                            <svg
                              viewBox="0 0 20 20"
                              fill="currentColor"
                              className="w-5 h-5 text-black cursor-pointer"
                              role="button"
                              aria-label="Remove Brand"
                              onClick={() => removeBrandInput(index)}
                            >
                              <path d="M6 2l2-2h4l2 2h4v2H2V2h4zM3 6h14l-1 14H4L3 6zm5 2v10h1V8H8zm3 0v10h1V8h-1z" />
                            </svg>
                          </div>
                        )}
                      </div>
                    ))}
                  </form>
                  <Buttons
                    addScreenTitle={addScreenTitle}
                    updateScreenTitle={updateScreenTitle}
                    handleSubmit={handleSubmit}
                    disabledBtn={submitBtnDisabled ? true : false}
                    cancel={cancel}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}
      <MainPopup
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={() => setpopUpOpen(true)}
      >
        <div>
          <PopUpScreenTitle
            title="Brand"
            setpopUpOpen={setpopUpOpen}
            viewDetails={viewDetails}
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
          />

          <BrandPopup data={brandPopupData} data2={brandPopupDropDownData} />
        </div>
        <PopUpButtons
          deleteDetails={deleteDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          rowIndex={rowIndex}
          handleSubmit={handleSubmit}
          disabledBtn={submitBtnDisabled ? true : false}
          cancel={cancel}
        />
      </MainPopup>
    </MainLayout>
  );
};

export default BrandMaster;
